// extracted by mini-css-extract-plugin
export default {"jpRunning":"JP_Footer_jpRunning__7bpoT","jpCurrentDate":"JP_Footer_jpCurrentDate__kFSda","jpFootage":"JP_Footer_jpFootage__2Q4Vl","higlight":"JP_Footer_higlight__L0JoO"};